export default function Pricing() {
  return (
    <section id="pricing" className="scroll-mt-20 bg-white py-16 md:py-24">
      <div className="mx-auto max-w-6xl px-4 md:px-6">
        <div className="grid gap-10 lg:grid-cols-2 lg:gap-16">
          <div>
            <p className="text-xs font-bold uppercase tracking-[0.2em] text-lime-600">Pricing</p>
            <h2 className="mt-3 font-heading text-3xl font-black leading-tight text-navy-950 md:text-4xl">
              料金・運用
            </h2>
          </div>

          <div className="border-l-2 border-lime-400 pl-6">
            <p className="font-heading text-xl font-black leading-relaxed text-navy-950 md:text-2xl">
              制作内容に合わせて、お見積もりします。
            </p>
            <p className="mt-5 text-base leading-relaxed text-navy-600">
              公開後の更新や管理方法も、利用期間に合わせてご相談いただけます。
            </p>
            <p className="mt-8 text-sm leading-relaxed text-navy-500">
              独自ドメインや外部サービスの費用が必要な場合は、別途ご案内します。
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}